module.exports = __webpack_public_path__ + "img/np_fan_green.15dc0c7c.svg";